// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P5dXu","field":"styles_field__1iAQS","fieldCol":"styles_fieldCol__1Subt","diffCol":"styles_diffCol__2d6Fk","diff":"styles_diff__Df8hA"};